import React, { useState } from "react";
import "./WeightBalancer.css";

export default function App() {
    const [searched, setSearched] = useState(0.5);
    let closest = 0;
    let solution = {};
    let closestSolution = {};
    const maxX = 6;
    const maxY = 4;
    const maxZ = 4;

    const handleIncrement = () => {
        setSearched((prevValue) => prevValue + 0.5);
    };

    const handleDecrement = () => {
        if (searched > 0.5) {
            setSearched((prevValue) => prevValue - 0.5);
        }
    };

    for (let x = maxX; x >= 0; x -= 2) {
        for (let y = maxY; y >= 0; y -= 2) {
            for (let z = maxZ; z >= 0; z -= 2) {
                const equationResult = 0.5 + 2 * x + 1.25 * y + z;
                if (equationResult === searched) {
                    solution = { x, y, z };
                    break;
                } else if (equationResult < searched && equationResult > closest) {
                    closest = equationResult;
                    closestSolution = { x, y, z };
                }
            }
        }
    }

    const formatSolution = (solution) => {
        return(
            <div>
                <div>{solution.x / 2} disque de 2kg</div>
                <div>{solution.y / 2} disques de  1.25kg</div>
                <div>{solution.z / 2} disques de  1kg</div>
            </div>
        ) ;
    };

    return (
        <div className="App">
            <h2 className="title">Target weight</h2>
            <form>
                <div className="input-container">
                    <button type="button" onClick={handleDecrement}>
                        -
                    </button>
                    <input
                        type="number"
                        name="searched"
                        value={searched}
                        step="0.5"
                        min="0"
                        onChange={(event) =>
                            setSearched(parseFloat(event.target.value))
                        }
                        style={{ appearance: "none" }}
                    />
                    <button type="button" onClick={handleIncrement}>
                        +
                    </button>
                </div>
            </form>
            {Object.keys(solution).length ? (
                <div className="solution-container">
                    <div className="weights-container">
                        <div className="left-weights">
                            <h2>Left Weights:</h2>
                            <p>{formatSolution(solution)}</p>
                        </div>
                        <div className="right-weights">
                            <h2>Right Weights:</h2>
                            <p>{formatSolution(solution)}</p>
                        </div>
                    </div>
                    <div className="total-weight">
                        <h2>Total Weight:</h2>
                        <div>{searched} kg</div>
                    </div>
                </div>
            ) : (
                <div className="solution-container">
                    <p>
                        No solution exists for {searched} kg. The closest lower weight is{" "}
                        {closest} kg:
                    </p>
                    <div className="weights-container">
                        <div className="left-weights">
                            <h2>Left Weights:</h2>
                            <p>{formatSolution(closestSolution)}</p>
                        </div>
                        <div className="right-weights">
                            <h2>Right Weights:</h2>
                            <p>{formatSolution(closestSolution)}</p>
                        </div>
                    </div>
                    <div className="total-weight">
                        <h2>Total Weight:</h2>
                        <div>{closest} kg</div>
                    </div>
                </div>
            )}
        </div>
    );
}
